<template>
  <qas :permission-menu="0" />
</template>
<script>
import '@telexpress_auth/vue-qas/dist/components/List.css';
import qas from '@telexpress_auth/vue-qas/dist/components/List.umd.min';

export default {
  components: {
    qas,
  },
};
</script>
